/**
 * C 端用户认证服务
 * 管理邀请码验证、注册、登录、token 刷新和注销
 */
import axios from 'axios';
import { config } from '../config';

const BASE = config.API_BASE_URL;

const KEYS = {
  access: 'user_access_token',
  refresh: 'user_refresh_token',
};

export const userAuthService = {
  // ── 存储 ──────────────────────────────────────────────
  getAccessToken: () => localStorage.getItem(KEYS.access),
  getRefreshToken: () => localStorage.getItem(KEYS.refresh),

  _save(access, refresh) {
    localStorage.setItem(KEYS.access, access);
    if (refresh) localStorage.setItem(KEYS.refresh, refresh);
  },

  clear() {
    localStorage.removeItem(KEYS.access);
    localStorage.removeItem(KEYS.refresh);
  },

  isLoggedIn() {
    return !!this.getAccessToken();
  },

  // ── 邀请码预检 ────────────────────────────────────────
  async validateInvite(code) {
    const res = await axios.post(`${BASE}/auth/user/validate-invite`, { code });
    return res.data; // { valid, message }
  },

  // ── 注册 ──────────────────────────────────────────────
  async register(username, password, inviteCode) {
    const res = await axios.post(`${BASE}/auth/user/register`, {
      username,
      password,
      invite_code: inviteCode,
    });
    this._save(res.data.access_token, res.data.refresh_token);
    return res.data;
  },

  // ── 登录 ──────────────────────────────────────────────
  async login(username, password) {
    const res = await axios.post(`${BASE}/auth/user/login`, { username, password });
    this._save(res.data.access_token, res.data.refresh_token);
    return res.data;
  },

  // ── 刷新 access token ─────────────────────────────────
  async refresh() {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) throw new Error('No refresh token');
    const res = await axios.post(`${BASE}/auth/user/refresh`, { refresh_token: refreshToken });
    localStorage.setItem(KEYS.access, res.data.access_token);
    return res.data.access_token;
  },

  // ── 注销 ──────────────────────────────────────────────
  async logout() {
    const refreshToken = this.getRefreshToken();
    if (refreshToken) {
      try {
        await axios.post(`${BASE}/auth/user/logout`, { refresh_token: refreshToken });
      } catch (_) { /* ignore */ }
    }
    this.clear();
  },
};

export default userAuthService;
